module.exports = __webpack_public_path__ + "resources/img/guide-bg.eb8cb011.png";